import { render } from "./CommonLayouts.vue?vue&type=template&id=bf75e1f8&scoped=true"
import script from "./CommonLayouts.vue?vue&type=script&lang=ts"
export * from "./CommonLayouts.vue?vue&type=script&lang=ts"

import "./CommonLayouts.vue?vue&type=style&index=0&id=bf75e1f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf75e1f8"

export default script